// This component handles the token received in the URL and stores it in localStorage.
// It also redirects the user to the dashboard or login page based on the token's presence.
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export const Token = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('token');

    if (token) {
      localStorage.setItem('token', `Bearer ${token}`);
      console.log('Token saved to localStorage:', token);
      navigate('/dashboard', { replace: true });
    } else {
      console.warn('No token found in query params');
      navigate('/', { replace: true });
    }
  }, [location, navigate]);

  return null;
};
